var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "grid files__file-link" }, [
      _c(
        "div",
        {
          staticClass:
            "grid__col--1 modal-file__icon-container h-center-align h-no-padding"
        },
        [
          _c("span", {
            staticClass:
              "glyphicon glyphicon-cloud-download queue-detail__glyph modal-file__icon modal-file__icon--blank",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid__col--11 h-no-padding modal-file__text-container h-no-padding h-no-margin"
        },
        [
          _c("div", {
            staticClass:
              "modal-file__title modal-file__title--blank modal-file--blank"
          })
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }